import _ from 'underscore';
import $ from 'jquery';
import MapConstants from 'constants/map/map';
import LocationService from 'views/utils/LeafletMap/MapServices/LocationService';

var BaiduLocationService = function(args) {
    LocationService.apply(this, args);
    return this;
};

BaiduLocationService.prototype = Object.create(LocationService.prototype);
BaiduLocationService.prototype.constructor = BaiduLocationService;

BaiduLocationService.prototype.fetch = function fetch(options, context) {
    var url = ['https://api.map.baidu.com/geocoder/v2/?'];
    url.push('ret_coordtype=bd09ll');
    url.push('&address=' + encodeURIComponent(options.address));
    url.push('&ak=' + MapConstants.baiduKey);
    url.push('&output=json');
    url.push('&callback=?');

    $.getJSON(url.join(''), function(response) {
        if (response.result) {
            var point = response.result.location;
            options.success.call(context, {
                address: options.address,
                location: [point.lat, point.lng]
            });
        } else {
            options.error.call(context, response, 'Unexpected data returned.');
        }
    }).fail(function(jqXHR, response, status) {
        options.error.call(context, response, status);
    });
};

export default BaiduLocationService;
